import {socketClient} from "../libs/socket";
import {useEffect, useRef, useState} from "react";
import _ from "lodash";
import {useQueryClient} from "@tanstack/react-query";
import {
    USER_CURRENT_COUNT_MESSENGER_KEY,
     USER_UNREAD_NOTIFICATIONS_KEY
} from "../api/public-voissa/users";

const useSocketClientOptionDefault = {
    onUpdate : ({error, data}) =>{}
}

const useSocketClient = (
        key = null,
        params = {},
        options = {
            onUpdate : ({error, data}) =>{}
        }
    ) => {
    const [observer, setObserver] = useState(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [data, setData] = useState({});
    const [error, setError] = useState(null);
    let currentRoom = _.get(params, 'roomId');
    options = {
        ...useSocketClientOptionDefault,
        ...options
    };

    const optionsRef = useRef(options);
    if (!_.isEqual(optionsRef.current, options)) {
        optionsRef.current = options
    }

    const paramsRef = useRef(params);
    if (!_.isEqual(paramsRef.current, params)) {
        paramsRef.current = params
    }

    useEffect(
        () => {
            const observerClient = socketClient.subscribe(key, paramsRef.current);
            setObserver(observerClient);
            setIsSuccess(true);
            return () => {
                observerClient.unsubscribe();
                setObserver(null);
                setIsSuccess(false);
            };
        },
        [key, paramsRef, currentRoom]
    );

    useEffect(
        () => {
            if (observer) {
                observer.onUpdate(async ({error, data}) => {
                    setData(data);
                    setError(error);
                    await optionsRef.current.onUpdate({error, data})
                });
            }
        },
        [observer, optionsRef]
    );
    return {
        isSuccess,
        observer,
        data,
        error
    };
}

const useSocketNotifications = () => {
    const queryClient = useQueryClient();

    const [res, setRes] = useState({});

    let updateData = async ({error, data}) =>{
        setRes({error, data});
        let total = parseInt(data?.total || 0);

        queryClient.setQueryData([USER_UNREAD_NOTIFICATIONS_KEY], () =>{
            return {
                total,
            }
        })

    }

    useSocketClient('UNREAD_NOTIFICATION', {}, {onUpdate : updateData});

    return res;
}

const useSocketVMessengerNotifications = () => {
    const queryClient = useQueryClient();
    const [res, setRes] = useState({});
    let updateData = async ({error, data}) =>{
        setRes({error, data});
        let total = parseInt(data?.total || 0);
        queryClient.setQueryData([USER_CURRENT_COUNT_MESSENGER_KEY], () =>{
            return {
                total,
            }
        })
    }

    useSocketClient('NOTIFICATION_V_MESSENGER', {}, {onUpdate : updateData});

    return res;
}

export {
    useSocketNotifications,
    useSocketVMessengerNotifications
};